function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';
const BaseComponent = ({
  size = 24,
  title,
  desc,
  titleId,
  descId,
  tabIndex = -1,
  focusable = false,
  role = 'img',
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  let ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? ` ${descId}` : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": ariaHidden,
    fill: "currentcolor",
    role: role,
    tabIndex: tabIndex,
    focusable: focusable
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.6V7a.967.967 0 00-.287-.713A.968.968 0 0011 6a.968.968 0 00-.713.287A.967.967 0 0010 7v4c0 .133.025.258.075.375.05.117.125.225.225.325l2 2c.2.2.433.3.7.3.267 0 .5-.1.7-.3.2-.2.3-.433.3-.7 0-.267-.1-.5-.3-.7L12 10.6zm-2.925 9.2c-2.033-.433-3.72-1.467-5.062-3.1S2 13.167 2 11c0-2.5.875-4.625 2.625-6.375S8.5 2 11 2s4.625.875 6.375 2.625S20 8.5 20 11c0 .717-.083 1.412-.25 2.088a9.186 9.186 0 01-.7 1.912h-6.1c-1.1 0-2.033.392-2.8 1.175C9.383 16.958 9 17.9 9 19c0 .133.004.267.012.4.009.133.03.267.063.4zM13 21h6c.55 0 1.02-.196 1.413-.587.391-.392.587-.863.587-1.413s-.196-1.02-.587-1.413A1.926 1.926 0 0019 17h-6c-.55 0-1.02.196-1.412.587A1.926 1.926 0 0011 19c0 .55.196 1.02.588 1.413.391.391.862.587 1.412.587zm0-1a.968.968 0 01-.713-.288A.968.968 0 0112 19c0-.283.096-.52.287-.712A.968.968 0 0113 18c.283 0 .52.096.713.288.191.191.287.429.287.712s-.096.52-.287.712A.968.968 0 0113 20zm3 0a.968.968 0 01-.713-.288A.968.968 0 0115 19c0-.283.096-.52.287-.712A.968.968 0 0116 18c.283 0 .52.096.712.288.192.191.288.429.288.712s-.096.52-.288.712A.968.968 0 0116 20zm3 0a.968.968 0 01-.712-.288A.968.968 0 0118 19c0-.283.096-.52.288-.712A.968.968 0 0119 18c.283 0 .52.096.712.288.192.191.288.429.288.712s-.096.52-.288.712A.968.968 0 0119 20z"
  }));
};
const SvgDelay = styled(BaseComponent).withConfig({
  displayName: "Delay__SvgDelay",
  componentId: "sc-179lr97-0"
})(["outline:none;"]);
SvgDelay.isIcon = true;
export default SvgDelay;